import { render } from "./Edit.vue?vue&type=template&id=1ed70075&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=ts"
export * from "./Edit.vue?vue&type=script&lang=ts"

import "./Edit.vue?vue&type=style&index=0&id=1ed70075&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1ed70075"

export default script